import { Component, Prop, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { parseUrl, stringifyUrl } from 'query-string';

@Component
export class FakeDropdown extends ThemeComponent {
    @Prop id!: string;
    @Prop label!: string;
    @Prop options!: string;
    @Prop fallback!: string;

    @Ref() target!: HTMLButtonElement;
    @Ref() targetText!: HTMLSpanElement;
    @Ref() option!: HTMLButtonElement[];
    @Ref() input!: HTMLInputElement;

    private _onChange = new SimpleEvent<string>();

    public get onChange() {
        return this._onChange.asEvent();
    }

    init() {
        // Init target click event listener
        this.$listen(this.target, 'click', () => this.toggleVisibility());

        // Init option click event listener
        if (this.option) {
            for (const option of this.option) {
                this.$listen(option, 'click', () => this.handleOptionSelect(option));
            }
        }
    }

    toggleVisibility() {
        this.classList.toggle('fake-dropdown--active');
    }

    handleOptionSelect(element: HTMLButtonElement) {
        // Get value selected
        const selectedOptionValue = element.getAttribute('data-value');
        const selectedOptionName = element.innerHTML;
        if (selectedOptionValue) {

            // Update hidden input
            this.input.value = selectedOptionValue;
            this._onChange.dispatch(this.input.value);

            // Update target inner HTML
            this.targetText.innerHTML = selectedOptionName;
        }

        // Remove old selected classes
        for (const option of this.option) {
            option.classList.remove('fake-dropdown__option--selected');
        }

        // Add selected class
        element.classList.add('fake-dropdown__option--selected');

        // Check for fallback
        if (element.hasAttribute('data-fallback') && selectedOptionValue) {
            const fallback = element.getAttribute('data-fallback');
            switch (fallback) {
                case 'sortBy':
                    this.sortBy(selectedOptionValue);
                    break;
            }
        }

        // Toggle visibility
        this.toggleVisibility();
    }

    sortBy(value: string) {
        const { url, query } = parseUrl(window.location.href);
        window.location.href = stringifyUrl({
            url,
            query: {
                ...query,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                sort_by: value
            }
        });
    }
}
